import { Category, Producer, ProducerRaw, SocialAudit } from '../models/producer';
import { convertToDecimalCoordinates } from './convertToDecimalCoordinates';

export const transformProducer = (producerRaw: ProducerRaw): Producer => {
  return {
    name: producerRaw.producer,
    category: getCategory(producerRaw.category),
    street: producerRaw.street,
    city: formatPlace(producerRaw.city),
    country: formatPlace(producerRaw.country),
    reviewDate: getReviewDate(producerRaw.review_date),
    employees: getEmployees(producerRaw.employees),
    position: convertToDecimalCoordinates(producerRaw.latitude, producerRaw.longitude),
    socialAudit: getSocialAudit(producerRaw.social_audit),
  };
};

export const transformProducers = (producersRaw: ProducerRaw[]): Producer[] =>
  producersRaw.map((producerRaw) => transformProducer(producerRaw));

function getCategory(categoryString?: string): Category {
  switch (categoryString) {
    case 'Bekleidung':
      return 'clothing';
    case 'Papeterie':
      return 'stationery';
    default:
      return 'household';
  }
}

function getSocialAudit(socialAuditString?: string): SocialAudit {
  switch (socialAuditString) {
    case 'amfori Social Audit':
      return 'amfori';
    case 'Sedex/SMETA':
      return 'sedex-smeta';
    case 'SA8000':
      return 'sa8000';
    default:
      return undefined;
  }
}

function formatPlace(place?: string | undefined) {
  if (place === undefined || place.length <= 2) {
    return place;
  }

  return place[0].toUpperCase() + place.slice(1).toLowerCase();
}

function getReviewDate(date?: string | number) {
  if (date === undefined) {
    return '-';
  }

  return date.toString().replace(' 00:00', '');
}

function getEmployees(employees?: string) {
  if (employees === undefined || employees === 'na') {
    return '-';
  }

  return employees;
}
